<template>
  <g fill-rule="evenodd">
    <path
      d="M18.4 15.2H8.8v-.8c0-.88-.72-1.6-1.6-1.6H4.8c-.88 0-1.6.72-1.6 1.6v.8H.8a.8.8 0 100 1.6h2.4v.8c0 .88.72 1.6 1.6 1.6h2.4c.88 0 1.6-.72 1.6-1.6v-.8h9.6a.8.8 0 000-1.6zM18.4 8.8H16V8c0-.88-.72-1.6-1.6-1.6H12c-.88 0-1.6.72-1.6 1.6v.8H.8a.8.8 0 000 1.6h9.6v.8c0 .88.72 1.6 1.6 1.6h2.4c.88 0 1.6-.72 1.6-1.6v-.8h2.4a.8.8 0 000-1.6zM18.4 2.4H8.8v-.8C8.8.72 8.08 0 7.2 0H4.8c-.88 0-1.6.72-1.6 1.6v.8H.8A.8.8 0 00.8 4h2.4v.8c0 .88.72 1.6 1.6 1.6h2.4c.88 0 1.6-.72 1.6-1.6V4h9.6a.8.8 0 000-1.6z"
    />
    <path class="secondary-color" d="M4.8 17.6h2.4v-3.2H4.8zM12 11.2h2.4V8H12zM4.8 4.8h2.4V1.6H4.8z" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ConfigurationIcon",
});
</script>
